export const logAnalyticsEvent = event => {
    if (window.dataLayer !== undefined) {
        window.dataLayer.push({ event: event });
    }
};
